import {Flex, Text} from "@mantine/core";
import { useSearchParams } from 'react-router-dom';

export const VerifyHint = () => {

    const [searchParams] = useSearchParams();

    const email = searchParams.get('email')

    return <Flex justify={"center"} align={"center"} h={"100vh"}>
        <Text>Bitte Verifizieren Sie Ihre Email Adresse, indem Sie auf den Link klicken der an <Text c={"lime"}>{email + " "}</Text>geschickt wurde</Text>
    </Flex>
}